var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMealTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM19.4 13.72V14.75H9.74V13.72C9.74 12.89 10.41 12.22 11.24 12.22H17.9C18.73 12.22 19.4 12.89 19.4 13.72ZM6.37 17.79L5.7 8.56H9.78V6.25C9.78 6.1 9.84 5.95 9.95 5.85L11.84 3.95L12.66 4.77L10.93 6.5V8.57H12.13L11.92 11.47H11.23C9.99 11.47 8.98 12.48 8.98 13.72V14.43H8.72V17.28H8.99C8.99 17.46 9.03 17.63 9.08 17.79H6.37ZM19.4 17.18C19.4 18.01 18.73 18.68 17.9 18.68H11.24C10.41 18.68 9.74 18.01 9.74 17.18V16.95H19.4V17.18ZM9.47 16.53V15.18H19.66V16.53H9.47Z",
    fill: "#99A1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMealTimes);
export default __webpack_public_path__ + "static/media/ic-meal-times.8026243461d9086602ce6700ac5db74e.svg";
export { ForwardRef as ReactComponent };